<div class="offerwrapper acvis-elevation" (dragover)="dragOver($event)" (drop)="dropp($event)">
    <div class="offerheader">
        <span multilang class="offerheadertext"><b>Angebot Nr. {{index()}}</b>
            {{datas?.CustomOffer?.TravelBookingType}}</span>
        <ng-container *ngIf="currentCustomer?.asPartner">
            <div class="actions">
                <mat-icon class="rmico mr3" (click)="openSetComment()" matTooltip="Extra info">comment
                </mat-icon>
                <button [draggable]="true" class="drg mr3" matTooltip="Position ändern"
                    (dragstart)="dragStart($event, index())">
                    <svg _ngcontent-soh-c164="" width="24px" fill="currentColor" viewBox="0 0 24 24">
                        <path _ngcontent-soh-c164=""
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path _ngcontent-soh-c164="" d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </button>
                <mat-icon class="rmico" (click)="removeFromListF()" matTooltip="Angebot löchen">cancel
                </mat-icon>
            </div>
        </ng-container>
    </div>
    <div class="offerbody">
        <div class="offerimgwrapper">
            <ng-container *ngIf="showImmages">
                <imageslider (clickOnImg)="openImageModal($event)" [showcounter]="false" [current]="0"
                    [data]="datas?.CustomOffer?.Accommodation?.ImageUrls?.ImageUrl" class="offerimg"></imageslider>
            </ng-container>
        </div>

        <div class="offerOperator" [style.background-color]="online()?.length > 0 ? '#ace59f': ''">
            <img *ngIf="datas?.CustomOffer?.Accommodation?.CatalogTourOperatorLogoUrl?.length > 0"
                src="{{datas?.CustomOffer?.Accommodation?.CatalogTourOperatorLogoUrl}}" height="24px"
                alt="{{datas?.CustomOffer?.Accommodation?.CatalogTourOperatorName}}" class="lazyload">
            <span multilang
                style="font-weight: 500;">{{datas?.CustomOffer?.Accommodation?.CatalogTourOperatorName}}</span>
        </div>
        <div class="offerschedule">
            <mat-icon class="unsetico">event</mat-icon>
            <span multilang class="offerscheduletext">
                <b>{{datas?.CustomOffer?.Accommodation?.DurationDays + ' ' +
                    datas?.CustomOffer?.Accommodation?.DurationUnit}}</b>
                {{datas?.CustomOffer?.Accommodation?.StartDate | date:'dd.MM.yyyy'}} -
                {{datas?.CustomOffer?.Accommodation?.EndDate | date:'dd.MM.yyyy'}}
            </span>
        </div>
        <div class="offerinfos">
            <div class="infobody">
                <div class="offerinfodet">
                    <mat-icon class="infoc">bedroom_child</mat-icon>
                    <span multilang
                        style="margin-left: .3rem;word-break: break-all;">{{datas?.CustomOffer?.Accommodation?.AccommodationTypeDescription}}</span>
                </div>
                <div class="offerinfodet">
                    <span multilang
                        style="margin-left: .3rem;">{{datas?.CustomOffer?.Accommodation?.BoardDescription}}</span>
                </div>
            </div>
            <div class="offerinfodet">
                <span multilang style="font-weight: bold;">
                    {{datas?.CustomOffer?.Accommodation?.City}}
                    {{datas?.CustomOffer?.Accommodation?.Country}}
                    <br><br>{{datas?.CustomOffer?.Accommodation?.AccommodationName}}</span>
            </div>
            <div class="offerinfodet">
                <span multilang>{{datas?.CustomOffer?.Accommodation?.Region}}</span>
            </div>
            <div class="offerinfodet" (click)="openDetail()">
                <span multilang class="minbtn noselect" matRipple>Mehr Details</span>
            </div>
        </div>
        <div class="offerprice">
            <div>
                <span multilang *ngIf="datas?.CustomOffer?.adults?.length > 0">Erwachsene :
                    {{datas?.CustomOffer?.adults}}</span>
                <span multilang style="margin-left: .5rem;" *ngIf="datas?.CustomOffer?.ChildrenCount?.length > 0">Kinder
                    :
                    {{datas?.CustomOffer?.ChildrenCount}}</span>
            </div>
            <div class="offerpriceTotal">
                <span multilang>Gesamtpreis:</span>
                <span multilang class="prccolor">{{datas?.CustomOffer?.Accommodation?.Price | number:'1.2-2'}}
                    {{datas?.CustomOffer?.Accommodation?.Currency}}</span>
            </div>
        </div>
        <button class="mhrd" (click)="gotoBuchen();">
            <div class="noselect bookingbtn">
                {{currentCustomer?.token?.length > 0 ? 'Buchen' : 'Anfrage senden'}}
            </div>
        </button>
    </div>
</div>

<ng-container *ngIf="showDetail">
    <clever-offerpackdetailmodal (triggerCloseModal)="closeModal($event)"
        [cmpRef]="component"></clever-offerpackdetailmodal>
</ng-container>